import { gql } from "@apollo/client";

export const CREATE_CATEGORY = gql`
  mutation CreateCategory($input: CategoryInput) {
    createCategory(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($id: ID!, $input: CategoryInput) {
    updateCategory(_id: $id, input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($id: ID!) {
    deleteCategory(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_CATEGORY_IS_USE = gql`
  mutation UpdateCategoryIsUse($id: ID!, $isUse: Boolean) {
    updateCategoryIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const GET_CATEGORY_PAGINATION = gql`
  query GetCategoryPagination(
    $isUse: Boolean
    $keyword: String
    $pagination: Boolean
    $limit: Int
    $page: Int
  ) {
    getCategoryPagination(
      isUse: $isUse
      keyword: $keyword
      pagination: $pagination
      limit: $limit
      page: $page
    ) {
      data {
        _id
        categoryKhName
        categoryEnName
        isUse
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
